import { ApiClient } from "../config/axiosConfig";
import { IPaginatedResponse } from "../models/Pagination";
import {
  ICreateProjectDocuments,
  ICreateProjectMember,
  ICreateProjectPhase,
  ICreateProjectPhaseMilestone,
  ICreateResearchProject,
  ICreateResearchPurchaseRequest,
  IFilterResearch,
  IListMaterialAwb,
  IProjectBudgetCategoryResponse,
  IProjectDocumentDownloadHistory,
  IProjectDocuments,
  IProjectMember,
  IProjectOverview,
  IProjectPhaseMilestone,
  IProjectPhases,
  IProjectPurchaseRequest,
  IResearchProject,
  IResearchPurchaseRequest,
  IUpdateProjectPhase,
  IUpdateResearchProject,
  IUpdateResearchPurchaseRequest,
} from "../models/Research";

export const researchService = {
  getAllResearchProject: async (params: IFilterResearch) => {
    const response = await ApiClient.GET<IPaginatedResponse<IResearchProject>>(
      "/research-projects",
      params,
    );
    return response;
  },
  getResearchProjectByAlias: async (alias: string) => {
    const response = await ApiClient.GET<IResearchProject>(
      `/research-projects/${alias}`,
    );
    return response;
  },
  createResearchProject: async (data: ICreateResearchProject) => {
    const response = await ApiClient.POST<IResearchProject>(
      "/research-projects",
      data,
    );
    return response;
  },
  getResearchProjectBudget: async (id: number) => {
    const response = await ApiClient.GET<IProjectBudgetCategoryResponse>(
      `/research-projects/${id}/budget`,
    );
    return response;
  },
  getResearchProjectPurchaseRequest: async (
    id: number,
    partNumber?: string,
  ) => {
    const url = partNumber
      ? `/research-projects/${id}/purchase-requests?partNumber=${encodeURIComponent(partNumber)}`
      : `/research-projects/${id}/purchase-requests`;
    const response = await ApiClient.GET<IProjectPurchaseRequest>(url);
    return response;
  },
  approvePurchaseRequestByDirector: async (id: number) => {
    return ApiClient.PATCH<IResearchPurchaseRequest>(
      `/research-projects/purchase-requests/${id}/approve-director`,
    );
  },
  requestPurchaseRequestForDirector: async (id: number) => {
    return ApiClient.PATCH<IResearchPurchaseRequest>(
      `/research-projects/purchase-requests/${id}/request-director`,
    );
  },
  createPurchaseRequest: async (data: ICreateResearchPurchaseRequest) => {
    return ApiClient.POST<IResearchPurchaseRequest>(
      "/research-projects/purchase-requests",
      data,
    );
  },
  updatePurchaseRequest: async (
    id: number,
    data: IUpdateResearchPurchaseRequest,
  ) => {
    return ApiClient.PUT<IResearchPurchaseRequest>(
      `/research-projects/purchase-requests/${id}`,
      data,
    );
  },
  updateResearchProject: async (id: number, data: IUpdateResearchProject) => {
    return ApiClient.PUT<IResearchProject>(`/research-projects/${id}`, data);
  },
  getProjectOverview: async () => {
    return ApiClient.GET<IProjectOverview>("/research-projects/overview");
  },
  getListAwbByMaterialId: async (materialId: number) => {
    const response = await ApiClient.GET<IListMaterialAwb[]>(
      `/list-materials-awb/${materialId}`,
    );
    return response;
  },
  uploadDocumentResearch: async (data: ICreateProjectDocuments) => {
    const response = await ApiClient.POST<IProjectDocuments>(
      `/project-documents`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response;
  },
  getDocumentByProjectId: async (projectId: number) => {
    const response = await ApiClient.GET<IProjectDocuments[]>(
      `/project-documents/${projectId}`,
    );
    return response;
  },
  // downloadDocument: async (fileUrl: string) => {
  //   const response = await ApiClient.GET(
  //     `/local-storage/download?path=${fileUrl}`,
  //     {},
  //     {
  //       responseType: "blob",
  //     },
  //   );
  //   return response;
  // },

  deleteDocumentProject: async (documentId: number) => {
    const response = await ApiClient.DELETE(`/project-documents/${documentId}`);
    return response;
  },
  downloadDocumentProject: async (documentId: number) => {
    const response = await ApiClient.GET<string>(
      `/project-documents/${documentId}/download/`,
    );
    return response;
  },
  getDownloadHistoryDocument: async (documentId: number) => {
    const response = await ApiClient.GET<IProjectDocumentDownloadHistory[]>(
      `/project-document-activities/${documentId}`,
    );
    return response;
  },
  getProjectMembers: async (projectId: number) => {
    const response = await ApiClient.GET<IProjectMember[]>(
      `/project-members/${projectId}`,
    );
    return response;
  },

  addBulkProjectMember: async (projectId: number, data: string[]) => {
    const response = await ApiClient.POST<IProjectMember[]>(
      `/project-members`,
      { projectId, data },
    );
    return response;
  },
  deleteProjectMember: async (memberId: number) => {
    const response = await ApiClient.DELETE(`/project-members/${memberId}`);
    return response;
  },

  getProjectPhases: async (projectId: number) => {
    const response = await ApiClient.GET<IProjectPhases[]>(
      `/project-phases/${projectId}`,
    );
    return response;
  },
  updateProjectPhases: async (id: number, data: IUpdateProjectPhase) => {
    const response = await ApiClient.PUT<IProjectPhases>(
      `/project-phases/${id}`,
      data,
    );
    return response;
  },
  createProjectPhases: async (data: ICreateProjectPhase) => {
    const response = await ApiClient.POST<IProjectPhases>(
      `/project-phases`,
      data,
    );
    return response;
  },
  deleteProjectPhases: async (phaseId: number) => {
    const response = await ApiClient.DELETE(`/project-phases/${phaseId}`);
    return response;
  },
  deleteProjectPhaseMilestone: async (milestoneId: number) => {
    const response = await ApiClient.DELETE(
      `/project-phase-milestones/${milestoneId}`,
    );
    return response;
  },
  createProjectPhaseMilestone: async (data: ICreateProjectPhaseMilestone) => {
    const response = await ApiClient.POST<IProjectPhaseMilestone>(
      `/project-phase-milestones`,
      data,
    );
    return response;
  },
};
